import React from 'react';
import { translate } from 'helpers/intl';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/SignupPages/ContractNotFound/messages';
import {
  AUTH_BY_CONTRACT,
  PERSONAL_INFO,
} from 'containers/SignupPages/constants';
import IsContractFoundResponse from 'containers/SignupPages/IsContractFoundResponse';

export type ContractNotFoundType = { intl: IntlShape; setSignupStep: Function };

const ContractNotFound = (props: ContractNotFoundType) => (
  <IsContractFoundResponse
    isFound={false}
    title={translate({ ...messages.title }, props)}
    nextLabel={translate({ ...messages.suivant }, props)}
    previousLabel={translate({ ...messages.precedent }, props)}
    subTitle={translate({ ...messages.subTitle }, props)}
    onClickNext={() => {
      props.setSignupStep(AUTH_BY_CONTRACT);
    }}
    onClickPrevious={() => {
      props.setSignupStep(PERSONAL_INFO);
    }}
  />
);

export default injectIntl(ContractNotFound);
